/**
 * @generated SignedSource<<56c13c51a61096f44b8831d959468186>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum AccessType {
  EDIT = "EDIT",
  VIEW = "VIEW",
}
export interface RequestPageAccessInput {
  accessType: AccessType;
  pageId: Scalars["String"]["input"];
}
export type SubmitAccessRequestMutation_requestPageAccess_RequestPageAccessPayload =
  {
    __typename?: "RequestPageAccessPayload";
    displayName: string;
  };
export type SubmitAccessRequestMutation_Mutation = {
  __typename?: "Mutation";
  requestPageAccess: SubmitAccessRequestMutation_requestPageAccess_RequestPageAccessPayload;
};
export type SubmitAccessRequestMutationVariables = Exact<{
  requestPageAccessInput: RequestPageAccessInput;
}>;
export type SubmitAccessRequestMutation = SubmitAccessRequestMutation_Mutation;
